<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2023-07-17 10:17:52
 * @FilePath: \jsczt\src\views\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="my_place">
      <span class="icons"><img src="../assets/place.png"/></span>
          <!-- <el-cascader
            v-model="value"
            :options="jsxoptions"
            :props="{ checkStrictly: true }"
            disabled
            @change="handleChange">
        </el-cascader> -->
        <el-input v-model="data" placeholder="请选择" readonly></el-input>
        <span class="icon iconfont icon-jiantouxia" v-if="!value"></span>
    </div>
  </template>

<script>
export default {
  name: 'myReginon',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      jsxoptions: [],
      data: this.value
    }
  },
  watch: {
    value: {
      handler (val) {
        this.data = this.value
      }
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped>
*{
  padding: 0;
  margin: 0;
}
a{
  text-decoration: none;
}
ul li{
  list-style: none;
}
.my_place /deep/ .el-input__inner {
  width: 166PX;
  height: 40PX;
  background: #fcfcfc;
  border: 1PX solid #4079ae;
  border-radius: 20PX;
  padding-left: 50PX;
  cursor: pointer !important;
  position: relative;
}
.icon{
  position: absolute;
  top: 14PX;
  margin-left: -30PX;
  font-size: 13PX;
  color: #dbdbdb;
  z-index: 9;
}
.icons {
  position: absolute;
  top: 10PX;
  margin-left: 30PX;
  z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/components/myRegions.vue